<template>
  <v-app id="app">
    <v-main>
      <v-container class="mb-4">
        <v-card max-width="420px" class="mt-8 mx-auto">
          <router-view/>
        </v-card>
      </v-container>
    </v-main>
  </v-app>
</template>
<script>

export default {
  data: () => ({
  }),
  methods: {

  },
  async created() {
    document.title = "Scan Purchase"
  },
}
</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background: #f5f5f5;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
